import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  mapContainer: {
    width: "100vw",
    height: "100vh",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    background: "#F7F7F7",
    "& .ol-popup  > div": {
      boxShadow: "0 3px 6px rgb(0 0 0 / 16%)",
      border: 0,
      borderRadius: 4
    },
    "& .ol-popup.default .anchor": {
      color: "#fff"
    },
    "& .ol-popup .ol-popup-content": {
      padding: 0
    },
    "& .ol-popup .closeBox": {
      background: "transparent",
      color: "#c3c3c3",
      "&:hover": {
        color: "#a4a4a4"
      }
    },
    "& .popup-content-wrapper": {
      padding: theme.spacing(2)
    },
    "& .popup-header": {
      ...theme.typography.subtitle2,
      fontSize: 13
    },
    "& .popup-content": {
      ...theme.typography.body2,
      fontSize: 12,
      color: "#808080",
      fontStyle: "italic",
      marginTop: 8
    },
    "& .popup-normal-content": {
      ...theme.typography.body2,
      fontSize: 12,
      marginTop: 8
    }
  },
  map: {
    width: "100%",
    height: "100%",
    position: "relative",
    top: 0,
    left: 0,
    zIndex: 0
  },
  popupWrapper: {}
}));

export default useStyles;
